var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
var Drag = function Drag(props) {
  return React.createElement(
    Icon,
    _extends({ viewBox: '0 0 6 22' }, props),
    React.createElement(
      'g',
      null,
      React.createElement(
        'title',
        null,
        'drag'
      ),
      React.createElement('path', { d: 'M4 20h2v2H4v-2zm0-5h2v2H4v-2zm0-5h2v2H4v-2zm0-5h2v2H4V5zm0-5h2v2H4V0zM0 20h2v2H0v-2zm0-5h2v2H0v-2zm0-5h2v2H0v-2zm0-5h2v2H0V5zm0-5h2v2H0V0z',
        fill: 'currentColor', fillRule: 'evenodd' })
    )
  );
};
/*eslint-enable */

export default Drag;
//# sourceMappingURL=Drag.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Icons/dist/components/Drag.js